import React from 'react';
import { components, ValueContainerProps } from 'react-select';

import { MReactSelectOption } from '../MSelect.model';

type Props<IsMulti extends boolean> = ValueContainerProps<MReactSelectOption, IsMulti>;

const MSelectValueContainerView = <IsMulti extends boolean>(props: React.PropsWithChildren<Props<IsMulti>>): JSX.Element => {
  return <components.ValueContainer {...props}>{props.children}</components.ValueContainer>;
};

MSelectValueContainerView.displayName = 'MSelectValueContainerView';
MSelectValueContainerView.defaultProps = {};

export default MSelectValueContainerView;
